import { defineComponent as Z, openBlock as t, createElementBlock as o, mergeProps as d, unref as V, renderSlot as m, createElementVNode as e, createCommentVNode as p } from "vue";
import { useScalarIcon as A } from "../hooks/useScalarIcon.js";
const i = { key: 0 }, u = { key: 1 }, M = { key: 2 }, g = { key: 3 }, f = { key: 4 }, k = { key: 5 }, h = {
  name: "ScalarIconLock"
}, _ = /* @__PURE__ */ Z({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(l) {
    const H = l, { bind: r, weight: n } = A(H);
    return (s, a) => (t(), o("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, V(r)), [
      m(s.$slots, "default"),
      V(n) === "bold" ? (t(), o("g", i, a[0] || (a[0] = [
        e("path", { d: "M208,76H180V56A52,52,0,0,0,76,56V76H48A20,20,0,0,0,28,96V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V96A20,20,0,0,0,208,76ZM100,56a28,28,0,0,1,56,0V76H100ZM204,204H52V100H204Zm-60-52a16,16,0,1,1-16-16A16,16,0,0,1,144,152Z" }, null, -1)
      ]))) : V(n) === "duotone" ? (t(), o("g", u, a[1] || (a[1] = [
        e("path", {
          d: "M216,96V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H208A8,8,0,0,1,216,96Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Zm-68-56a12,12,0,1,1-12-12A12,12,0,0,1,140,152Z" }, null, -1)
      ]))) : V(n) === "fill" ? (t(), o("g", M, a[2] || (a[2] = [
        e("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm-80,84a12,12,0,1,1,12-12A12,12,0,0,1,128,164Zm32-84H96V56a32,32,0,0,1,64,0Z" }, null, -1)
      ]))) : V(n) === "light" ? (t(), o("g", g, a[3] || (a[3] = [
        e("path", { d: "M208,82H174V56a46,46,0,0,0-92,0V82H48A14,14,0,0,0,34,96V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V96A14,14,0,0,0,208,82ZM94,56a34,34,0,0,1,68,0V82H94ZM210,208a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V96a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Zm-72-56a10,10,0,1,1-10-10A10,10,0,0,1,138,152Z" }, null, -1)
      ]))) : V(n) === "regular" ? (t(), o("g", f, a[4] || (a[4] = [
        e("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Zm-68-56a12,12,0,1,1-12-12A12,12,0,0,1,140,152Z" }, null, -1)
      ]))) : V(n) === "thin" ? (t(), o("g", k, a[5] || (a[5] = [
        e("path", { d: "M208,84H172V56a44,44,0,0,0-88,0V84H48A12,12,0,0,0,36,96V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V96A12,12,0,0,0,208,84ZM92,56a36,36,0,0,1,72,0V84H92ZM212,208a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V96a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-76-56a8,8,0,1,1-8-8A8,8,0,0,1,136,152Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  _ as default
};
